export default {
  default: 'Default',
  bankAccountBank: 'Bank Account - Bank',
  bankAccountClient: 'Bank Account - Client'
}
